import { Grid } from '@mui/material'
import { isEqual } from 'lodash'
import { memo, useState } from 'react'
import Questionario from '../componente/Questionario'

const VisualizaResposta = ({ dados }) => {
  const [questionario, setQuestionario] = useState({
    questionario: { idQuestionario: dados[1] },
    resposta: { idResposta: dados[0] || undefined },
  })

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Questionario
          questionario={questionario}
          setQuestionario={setQuestionario}
          dsNome={dados[5]}
          idPaciente={dados[4]}
          disabled={false}
        />
      </Grid>
    </Grid>
  )
}

export default memo(VisualizaResposta, isEqual)
